import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { checkValid, getErrorText, getIntFromTime, getTimeFromInt } from './tools';
import { VALIDATION_EMPTY_FIELD } from '../hooks/useForm/validate';

export const useTimeField = (error, required, defaultValue, onEditField) => {
    const [errorText, setErrorText] = useState('');
    const [value, setValue] = useState(defaultValue === undefined || defaultValue === null ? '' : getTimeFromInt(defaultValue));
    const { t: translate } = useTranslation();
    let customHelperText = errorText && errorText !== translate(VALIDATION_EMPTY_FIELD) ? errorText : '';

    useEffect(() => {
        setValue(defaultValue === undefined || defaultValue === null ? '' : getTimeFromInt(defaultValue));
    }, [defaultValue]);

    useEffect(() => {
        setErrorText(getErrorText(error, defaultValue, required, translate));
    }, [error, translate]);

    const handleFocus = useCallback(() => setErrorText(''), []);
    const handleBlur = useCallback((evt) => {
        const fieldValue = evt.currentTarget.value;
        if (checkValid(fieldValue) && fieldValue.length === 5) {
            var value = getIntFromTime(fieldValue);
            onEditField(evt.target.name, value);
        } else if (fieldValue !== '') {
            setErrorText(translate('errors.validate.fieldIsIncorrect'));
        } else {
            if (fieldValue === '' && required) {
                setErrorText(translate(VALIDATION_EMPTY_FIELD));
            }

            onEditField(evt.target.name, undefined);
        }
    }, []);

    const handleChange = useCallback((evt) => {
        let value = evt.target.value;

        setValue((prevState) => {
            if (!(value === prevState || value.length > 5) && checkValid(value)) {
                if (value.length === 2 && prevState.length !== 3 && value.indexOf(':') === -1) {
                    value = value + ':';
                }

                if (value.length === 2 && prevState.length === 3) {
                    value = value.slice(0, 1);
                }

                return value;
            }

            return prevState;
        });
    }, []);

    return {
        value,
        customHelperText,
        handleBlur,
        handleChange,
        handleFocus,
    };
};
